import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { LanguageEnum, SEARCH_INFORMATION_PAGE_SIZE_RESULTS, SEARCH_RESULTS_PAGE_SIZE_REDIS_TTL, MULTI_HOTEL_AVAILABILITIES_QUERY_PI_V2, MULTI_HOTEL_AVAILABILITIES_QUERY, PROMO_CODE_COOKIE, HotelBrand, ROOM_CODES } from '@whitbread-eos/api';
import { getCookie } from 'cookies-next';
import { MAX_ROOMS_SEARCH_LIMIT } from '../global-constants';
import { setCookieWithDefaultDomain } from '../helpers/cookies';
import { graphQLRequest } from '../hooks';
import { logger } from '../logger/logger';
import { RedisKeyPrefix, RedisStorageServer } from '../storage/RedisStorageServer';
import { getAuthCookie } from './auth';
import { getDistanceUnitBasedOnLocale } from './getters';
export var getPlace = (multiSearchParams, language) => {
  var _multiSearchParams$co;
  var place = {
    location: multiSearchParams !== null && multiSearchParams !== void 0 && multiSearchParams.placeId ? multiSearchParams.placeId : (_multiSearchParams$co = multiSearchParams === null || multiSearchParams === void 0 ? void 0 : multiSearchParams.coordinates) !== null && _multiSearchParams$co !== void 0 ? _multiSearchParams$co : '',
    locationFormat: multiSearchParams !== null && multiSearchParams !== void 0 && multiSearchParams.placeId ? 'PLACEID' : 'LATLONG',
    radius: language === LanguageEnum.ENGLISH ? 30 : 50,
    radiusUnit: getDistanceUnitBasedOnLocale(language !== null && language !== void 0 ? language : LanguageEnum.ENGLISH)
  };
  return place;
};
export function getDefaultRooms(query) {
  var noOfRooms = Number(query.ROOMS);
  if (!noOfRooms) {
    return [{
      adults: 1,
      children: 0,
      shouldIncludeCot: false,
      roomType: 'DB'
    }];
  }
  var defaultRooms = [];
  for (var idx = 0; idx < noOfRooms && idx < MAX_ROOMS_SEARCH_LIMIT; idx++) {
    var defaultRoom = {
      adults: Number(query["ADULT".concat(idx + 1)]),
      children: Number(query["CHILD".concat(idx + 1)]),
      shouldIncludeCot: !!Number(query["COT".concat(idx + 1)]),
      shouldBeAccessible: query["INTTYP".concat(idx + 1)] === ROOM_CODES.accessible,
      roomType: query["INTTYP".concat(idx + 1)]
    };
    defaultRooms.push(defaultRoom);
  }
  return defaultRooms;
}
export function getSearchResultsPageSize(_x, _x2, _x3) {
  return _getSearchResultsPageSize.apply(this, arguments);
}
function _getSearchResultsPageSize() {
  _getSearchResultsPageSize = _asyncToGenerator(function* (language, country, queryClient) {
    var redisKeyPrefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : RedisKeyPrefix.COMMON;
    logger.info({
      country,
      language
    }, 'FETCH_SEARCH_RESULTS_INFORMATION_START');
    var cachedData;
    var redisStorage;
    var cacheKey = "".concat(redisKeyPrefix, "::srp:page-size:").concat(country, "-").concat(language);
    try {
      redisStorage = RedisStorageServer.getInstance();
      cachedData = yield redisStorage.getItem(cacheKey);
    } catch (error) {
      logger.error({
        error
      }, 'FETCH_SEARCH_RESULTS_INFORMATION_REDIS_ERROR');
    }
    try {
      var _searchInformationDat, _searchInformationDat2, _redisStorage;
      if (cachedData) {
        var _searchResultsPageSize = JSON.parse(cachedData);
        logger.info({
          cacheKey,
          searchResultsPageSize: _searchResultsPageSize
        }, 'FETCH_SEARCH_RESULTS_INFORMATION_END');
        return _searchResultsPageSize;
      }
      var searchInformationData = yield queryClient.fetchQuery({
        queryKey: ['searchInformationPageSize', country, language],
        queryFn: () => graphQLRequest(SEARCH_INFORMATION_PAGE_SIZE_RESULTS, {
          country,
          language
        })
      });
      var _ref2 = (_searchInformationDat = searchInformationData === null || searchInformationData === void 0 || (_searchInformationDat2 = searchInformationData.searchInformation) === null || _searchInformationDat2 === void 0 || (_searchInformationDat2 = _searchInformationDat2.config) === null || _searchInformationDat2 === void 0 ? void 0 : _searchInformationDat2.api) !== null && _searchInformationDat !== void 0 ? _searchInformationDat : {},
        initialPageSize = _ref2.initialPageSize,
        lazyLoadPageSize = _ref2.lazyLoadPageSize;
      var searchResultsPageSize = {
        initialPageSize,
        lazyLoadPageSize
      };
      yield (_redisStorage = redisStorage) === null || _redisStorage === void 0 ? void 0 : _redisStorage.setItem(cacheKey, JSON.stringify(searchResultsPageSize), SEARCH_RESULTS_PAGE_SIZE_REDIS_TTL);
      logger.info({
        searchResultsPageSize
      }, 'FETCH_SEARCH_RESULTS_INFORMATION_END');
      return searchResultsPageSize;
    } catch (error) {
      logger.error({
        error
      }, 'FETCH_SEARCH_RESULTS_INFORMATION_ERROR');
      return null;
    }
  });
  return _getSearchResultsPageSize.apply(this, arguments);
}
export function readPromotionsInformation(input) {
  var _hotelAvailabilityQue, _promoQuery$state$dat, _promoQuery$state;
  if (!(input !== null && input !== void 0 && input.dehydratedState) || !Array.isArray(input.dehydratedState.queries)) {
    return null;
  }
  var queries = input.dehydratedState.queries;
  var hotelAvailabilityQuery = queries.find(q => Array.isArray(q === null || q === void 0 ? void 0 : q.queryKey) && q.queryKey.some(key => typeof key === 'string' && key.toLowerCase().includes('hotelavailability')));
  var nestedPromotionsInformation = hotelAvailabilityQuery === null || hotelAvailabilityQuery === void 0 || (_hotelAvailabilityQue = hotelAvailabilityQuery.state) === null || _hotelAvailabilityQue === void 0 || (_hotelAvailabilityQue = _hotelAvailabilityQue.data) === null || _hotelAvailabilityQue === void 0 || (_hotelAvailabilityQue = _hotelAvailabilityQue.hotelAvailability) === null || _hotelAvailabilityQue === void 0 ? void 0 : _hotelAvailabilityQue.promotionsInformation;
  if (nestedPromotionsInformation) {
    return nestedPromotionsInformation;
  }
  var promoQuery = queries.find(q => Array.isArray(q === null || q === void 0 ? void 0 : q.queryKey) && q.queryKey.some(key => typeof key === 'string' && key.toLowerCase().includes('promotionsinformation')));
  return (_promoQuery$state$dat = promoQuery === null || promoQuery === void 0 || (_promoQuery$state = promoQuery.state) === null || _promoQuery$state === void 0 || (_promoQuery$state = _promoQuery$state.data) === null || _promoQuery$state === void 0 ? void 0 : _promoQuery$state.promotionsInformation) !== null && _promoQuery$state$dat !== void 0 ? _promoQuery$state$dat : null;
}
export function shouldDisplayPromoBanner(type, promotionBannerData, promotionBanner, router) {
  var _router$query;
  var hasDocument = typeof document !== 'undefined';
  var promoCode = hasDocument ? getCookie(PROMO_CODE_COOKIE) : '';
  var landingPagePromo = router === null || router === void 0 || (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.PROMOID;
  var summerPromoEnabled = promotionBanner === null || promotionBanner === void 0 ? void 0 : promotionBanner.enabled;
  var siteWidePromo = promotionBannerData === null || promotionBannerData === void 0 ? void 0 : promotionBannerData.showPromo;
  if (landingPagePromo && hasDocument) {
    setCookieWithDefaultDomain(PROMO_CODE_COOKIE, null, -1);
  }
  if (type === 'breakfastPromo') {
    return Boolean(promoCode && !landingPagePromo);
  }
  if (type === 'summerPromo') {
    return Boolean(!promoCode && !landingPagePromo && !siteWidePromo && summerPromoEnabled);
  }
  return false;
}
export function getBrandFromSnowDropSuggestions(_x4) {
  return _getBrandFromSnowDropSuggestions.apply(this, arguments);
}
function _getBrandFromSnowDropSuggestions() {
  _getBrandFromSnowDropSuggestions = _asyncToGenerator(function* (snowdropSuggestionsResponse) {
    try {
      var _snowdropSuggestionsR, _snowdropSuggestionsR2;
      if (!snowdropSuggestionsResponse) return null;
      var initialBrand = getBrand(snowdropSuggestionsResponse === null || snowdropSuggestionsResponse === void 0 || (_snowdropSuggestionsR = snowdropSuggestionsResponse.properties) === null || _snowdropSuggestionsR === void 0 || (_snowdropSuggestionsR = _snowdropSuggestionsR[0]) === null || _snowdropSuggestionsR === void 0 ? void 0 : _snowdropSuggestionsR.brand);
      if (initialBrand) {
        return initialBrand;
      }
      var suggestions = (_snowdropSuggestionsR2 = snowdropSuggestionsResponse === null || snowdropSuggestionsResponse === void 0 ? void 0 : snowdropSuggestionsResponse.places) !== null && _snowdropSuggestionsR2 !== void 0 ? _snowdropSuggestionsR2 : [];
      if (!Array.isArray(suggestions) || suggestions.length === 0) {
        return null;
      }
      for (var place of suggestions) {
        var _place$suggestion, _suggestionText$split;
        var suggestionText = place === null || place === void 0 || (_place$suggestion = place.suggestion) === null || _place$suggestion === void 0 ? void 0 : _place$suggestion.trim();
        if (!suggestionText) continue;
        var lastWord = (_suggestionText$split = suggestionText.split(/\s+/).pop()) === null || _suggestionText$split === void 0 ? void 0 : _suggestionText$split.toLowerCase();
        if (lastWord === 'germany') {
          return HotelBrand.PID;
        }
      }
      return HotelBrand.PI;
    } catch (_unused) {
      return null;
    }
  });
  return _getBrandFromSnowDropSuggestions.apply(this, arguments);
}
export function getPromoId(rawPromoId) {
  if (Array.isArray(rawPromoId)) {
    var _rawPromoId$;
    return (_rawPromoId$ = rawPromoId[0]) !== null && _rawPromoId$ !== void 0 ? _rawPromoId$ : null;
  }
  return (rawPromoId === null || rawPromoId === void 0 ? void 0 : rawPromoId.trim()) || null;
}
export function getBrand(brand) {
  if (!brand) return null;
  return brand;
}
export function getHotelBrandFromSearchResults(hotelAvailabilities) {
  var _firstAvailableHotel$;
  if (!Array.isArray(hotelAvailabilities) || (hotelAvailabilities === null || hotelAvailabilities === void 0 ? void 0 : hotelAvailabilities.length) === 0) {
    return null;
  }
  var firstAvailableHotel = hotelAvailabilities.find(h => {
    var _h$hotelAvailability;
    return (h === null || h === void 0 || (_h$hotelAvailability = h.hotelAvailability) === null || _h$hotelAvailability === void 0 ? void 0 : _h$hotelAvailability.available) === true;
  });
  var brand = firstAvailableHotel === null || firstAvailableHotel === void 0 || (_firstAvailableHotel$ = firstAvailableHotel.hotelInformation) === null || _firstAvailableHotel$ === void 0 ? void 0 : _firstAvailableHotel$.brand;
  if (!brand) {
    return null;
  }
  return getBrand(brand);
}
export function extractMultiHotelAvailabilities(input) {
  var _input$dehydratedStat, _ref, _hotelQuery$state$dat, _hotelQuery$state, _hotelQuery$state2;
  var queries = input === null || input === void 0 || (_input$dehydratedStat = input.dehydratedState) === null || _input$dehydratedStat === void 0 ? void 0 : _input$dehydratedStat.queries;
  if (!Array.isArray(queries)) return [];
  var hotelQuery = queries === null || queries === void 0 ? void 0 : queries.find(q => {
    var _q$queryKey, _q$queryKey$some;
    return q === null || q === void 0 || (_q$queryKey = q.queryKey) === null || _q$queryKey === void 0 || (_q$queryKey$some = _q$queryKey.some) === null || _q$queryKey$some === void 0 ? void 0 : _q$queryKey$some.call(_q$queryKey, k => {
      var _k$includes, _k$includes2;
      return (k === null || k === void 0 || (_k$includes = k.includes) === null || _k$includes === void 0 ? void 0 : _k$includes.call(k, 'multiHotelAvailabilities')) || (k === null || k === void 0 || (_k$includes2 = k.includes) === null || _k$includes2 === void 0 ? void 0 : _k$includes2.call(k, 'hotelAvailabilities'));
    });
  });
  return (_ref = (_hotelQuery$state$dat = hotelQuery === null || hotelQuery === void 0 || (_hotelQuery$state = hotelQuery.state) === null || _hotelQuery$state === void 0 || (_hotelQuery$state = _hotelQuery$state.data) === null || _hotelQuery$state === void 0 || (_hotelQuery$state = _hotelQuery$state.hotelAvailabilitiesV2) === null || _hotelQuery$state === void 0 ? void 0 : _hotelQuery$state.multiHotelAvailabilities) !== null && _hotelQuery$state$dat !== void 0 ? _hotelQuery$state$dat : hotelQuery === null || hotelQuery === void 0 || (_hotelQuery$state2 = hotelQuery.state) === null || _hotelQuery$state2 === void 0 || (_hotelQuery$state2 = _hotelQuery$state2.data) === null || _hotelQuery$state2 === void 0 || (_hotelQuery$state2 = _hotelQuery$state2.hotelAvailabilities) === null || _hotelQuery$state2 === void 0 ? void 0 : _hotelQuery$state2.multiHotelAvailabilities) !== null && _ref !== void 0 ? _ref : [];
}
export var HOTEL_AVAILABILITIES_QUERY_KEY = 'hotelAvailabilities';
export var HOTEL_AVAILABILITIES_QUERY_KEY_PI = 'hotelAvailabilitiesV2';
export function buildBaseHotelAvailabilitiesQueryKey(paramsForQuery) {
  return [paramsForQuery.startDate, paramsForQuery.endDate, paramsForQuery.rooms, paramsForQuery.place, paramsForQuery.oldWorldChannel, paramsForQuery.channel, paramsForQuery.subChannel, paramsForQuery.page, paramsForQuery.initialPageSize, paramsForQuery.lazyLoadPageSize, paramsForQuery.country, paramsForQuery.language, paramsForQuery.sort, paramsForQuery.filters];
}
export function extractHotelAvailabilitiesResult(root) {
  return {
    results: root.multiHotelAvailabilities,
    total: root.total,
    promotionsInformation: root === null || root === void 0 ? void 0 : root.promotionsInformation
  };
}
export function getNewSearchResultsPI(_x5, _x6, _x7, _x8) {
  return _getNewSearchResultsPI.apply(this, arguments);
}
function _getNewSearchResultsPI() {
  _getNewSearchResultsPI = _asyncToGenerator(function* (queryClient, paramsForQuery, promoId, isPromotionsInHotelAvailabilityEnabled) {
    var _paramsForQuery$sortO, _paramsForQuery$sortO2, _paramsForQuery$sortO3, _paramsForQuery$sortO4;
    var queryResult = yield queryClient.fetchQuery({
      queryKey: [HOTEL_AVAILABILITIES_QUERY_KEY_PI, ...buildBaseHotelAvailabilitiesQueryKey(paramsForQuery), paramsForQuery.ratePlanCodes, (_paramsForQuery$sortO = paramsForQuery.sortOption) === null || _paramsForQuery$sortO === void 0 ? void 0 : _paramsForQuery$sortO.rcPriceModifier, (_paramsForQuery$sortO2 = paramsForQuery.sortOption) === null || _paramsForQuery$sortO2 === void 0 ? void 0 : _paramsForQuery$sortO2.rcDistanceModifier, (_paramsForQuery$sortO3 = (_paramsForQuery$sortO4 = paramsForQuery.sortOption) === null || _paramsForQuery$sortO4 === void 0 ? void 0 : _paramsForQuery$sortO4.rcHubModifier) !== null && _paramsForQuery$sortO3 !== void 0 ? _paramsForQuery$sortO3 : null],
      queryFn: () => graphQLRequest(MULTI_HOTEL_AVAILABILITIES_QUERY_PI_V2, _objectSpread(_objectSpread({}, paramsForQuery), isPromotionsInHotelAvailabilityEnabled && {
        promotionCode: promoId
      }))
    });
    return extractHotelAvailabilitiesResult(queryResult.hotelAvailabilitiesV2);
  });
  return _getNewSearchResultsPI.apply(this, arguments);
}
export function getNewSearchResultsBB(_x9, _x0, _x1, _x10) {
  return _getNewSearchResultsBB.apply(this, arguments);
}
function _getNewSearchResultsBB() {
  _getNewSearchResultsBB = _asyncToGenerator(function* (queryClient, paramsForQuery, promoId, isPromotionsInHotelAvailabilityEnabled) {
    var _paramsForQuery$sortO5, _paramsForQuery$sortO6;
    var queryResult = yield queryClient.fetchQuery({
      queryKey: [HOTEL_AVAILABILITIES_QUERY_KEY, ...buildBaseHotelAvailabilitiesQueryKey(paramsForQuery), (_paramsForQuery$sortO5 = paramsForQuery.sortOption) === null || _paramsForQuery$sortO5 === void 0 ? void 0 : _paramsForQuery$sortO5.rcPriceModifier, (_paramsForQuery$sortO6 = paramsForQuery.sortOption) === null || _paramsForQuery$sortO6 === void 0 ? void 0 : _paramsForQuery$sortO6.rcDistanceModifier],
      queryFn: () => graphQLRequest(MULTI_HOTEL_AVAILABILITIES_QUERY, _objectSpread(_objectSpread({}, paramsForQuery), {}, {
        idToken: getAuthCookie()
      }, isPromotionsInHotelAvailabilityEnabled && {
        promotionCode: promoId
      }))
    });
    return extractHotelAvailabilitiesResult(queryResult.hotelAvailabilities);
  });
  return _getNewSearchResultsBB.apply(this, arguments);
}
export function getNewSearchResultsCCUI(_x11, _x12, _x13, _x14) {
  return _getNewSearchResultsCCUI.apply(this, arguments);
}
function _getNewSearchResultsCCUI() {
  _getNewSearchResultsCCUI = _asyncToGenerator(function* (queryClient, paramsForQuery, promoId, isPromotionsInHotelAvailabilityEnabled) {
    var hotelAvailablilitiesQueryKey = ['hotelAvailabilities', ...buildBaseHotelAvailabilitiesQueryKey(paramsForQuery)];
    var queryResult = yield queryClient.fetchQuery({
      queryKey: paramsForQuery.companyId ? [...hotelAvailablilitiesQueryKey, paramsForQuery.companyId] : hotelAvailablilitiesQueryKey,
      queryFn: () => graphQLRequest(MULTI_HOTEL_AVAILABILITIES_QUERY, _objectSpread(_objectSpread({}, paramsForQuery), isPromotionsInHotelAvailabilityEnabled && !paramsForQuery.companyId && {
        promotionCode: promoId
      }))
    });
    return extractHotelAvailabilitiesResult(queryResult.hotelAvailabilities);
  });
  return _getNewSearchResultsCCUI.apply(this, arguments);
}
export function setPromoInfoState(promotionsInformation, setPromotionBannerData, flag) {
  if (flag && promotionsInformation) {
    setPromotionBannerData(promotionsInformation);
  }
}